import AuditTable from "./AuditTable";

export default AuditTable;